import {
  GET_SUB_SECTORS
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_SUB_SECTORS] (state, subSectors) {
    state.all = subSectors
  }
}

export default { state, mutations }



// WEBPACK FOOTER //
// ./src/vuex/modules/subsectors.js